"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/ArchivedBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _icons = require('./icons');





const ArchivedBar = ({ onBackToActive }) => (
  _react2.default.createElement('div', { className: "inbox-archived-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 10}}
    , _react2.default.createElement(_icons.ArchiveIcon, { className: "inbox-archived-bar--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} )
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}, "Archived chats" )
    , _react2.default.createElement('button', { type: "button", className: "inbox-archived-bar--back", onClick: onBackToActive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}, "Back to active"

    )
  )
)

exports. default = _react.memo.call(void 0, ArchivedBar)
